module.exports = __webpack_public_path__ + "static/media/sg.6d7a844b.webp";